import { useEffect, useState, useContext, useRef } from 'react';
import { FaBell } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import AppContext from '../../../context/AppContext';
import echo from '../../../echo';
import '../../../assets/css/Drivers/general/DriverHeader.css';

const DriverHeader = ({screenName, centered = true}) => {
  const navigate = useNavigate();
  const { authToken } = useContext(AppContext);
  const [unreadCount, setUnreadCount] = useState(0);
  const channelRef = useRef(null);
  const isFirstCleanup = useRef(true);

  const handleNotification = () => {
    navigate('/driver-notification-list');
  };

  useEffect(() => {
    const token = authToken || localStorage.getItem("authToken");
    if (!token) return;

    let driverId = null;
    try {
      const decoded = jwtDecode(token);
      driverId = decoded.sub || decoded.id;
    } catch (err) {
      console.log("Token decode error:", err);
      return;
    }

    if (!driverId) return;

    const channelName = `driver-notifications.${driverId}`;
    const channel = echo.channel(channelName);
    channelRef.current = channelName;

    channel.listen('.new-notification', (data) => {
      console.log("New real-time notification (driver):", data);
      setUnreadCount((prev) => prev + 1);

      const audio = new Audio('/notification-sound.mp3');
      audio.play().catch((err) => console.log("Sound play error:", err));
    });

    return () => {
      if (isFirstCleanup.current) {
        isFirstCleanup.current = false;
        return;
      }
      if (channelRef.current) {
        echo.leaveChannel(channelRef.current);
        channelRef.current = null;
      }
    };
  }, [authToken]);

  return(
    <div className="driver-header">
      <div className={`driver-header__logo-wrapper ${centered ? 'driver-header__logo-wrapper--centered' : ''}`}>
        <span className="driver-header__logo-text">{screenName}</span>
      </div>
      
      {/* ⭐ Always render div, conditionally show button */}
      <div className="driver-header__header-icons">
        {screenName === "TrustiDrive" && (
          <button 
            className="driver-header__header-btn"
            onClick={handleNotification}
            style={{ position: 'relative' }}
          >
            <FaBell size={20} />
            {unreadCount > 0 && (
              <span
                style={{
                  position: 'absolute',
                  top: '-4px',
                  right: '-4px',
                  backgroundColor: '#ff3b30',
                  color: '#fff',
                  borderRadius: '50%',
                  fontSize: '10px',
                  width: '16px',
                  height: '16px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {unreadCount}
              </span>
            )}
          </button>
        )}
      </div>
    </div>
  );
};

export default DriverHeader;